import moduleTemplate from './moduleTemplate'
import trackDevicesAPI from '@/api/track-devices'

export default moduleTemplate(trackDevicesAPI)
